module.exports = __webpack_public_path__ + "static/media/joint-dark.ba49339a.png";